// import React, { useEffect, useContext } from "react";
// import { Container, Row, Col, Card } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
// import NavbarComp1 from "../components/Navbar1";
// import loginImg from "../images/audio-description.png";
// import audioconverterImg from "../images/isl-video.png";
// import { UserContext } from "../jsx/UserContext";
// import "../css/main.css";
// import Footer from "../components/Footer";

// function Dashboard() {
  
//   const { userSession } = useContext(UserContext);
//   const navigate = useNavigate();

//   // useEffect(() => {
//   //   if (!userSession?.name) {
//   //     navigate("/login");
//   //   }
//   // }, [userSession, navigate]);
// useEffect(() => {
//   const storedSession = JSON.parse(localStorage.getItem("userSession"));

//   if (!storedSession?.access_token || Date.now() > storedSession.expiresAt) {
//     localStorage.removeItem("userSession");
//     navigate("/login", { replace: true });
//   }
// }, []);

//   return (
// <div class="main-div">
//   {/* Skip to main content link */}
//   <a
//     href="#main-content"
//     className="visually-hidden-focusable"
//     style={{
//       position: "absolute",
//       top: "-40px",
//       left: "0",
//       background: "#000",
//       color: "#fff",
//       padding: "8px 16px",
//       zIndex: "1000",
//       borderRadius: "4px",
//     }}
//     onFocus={(e) => (e.target.style.top = "0")}
//     onBlur={(e) => (e.target.style.top = "-40px")}
//   >
//     Skip to main content
//   </a>

//   <NavbarComp1 />

//   <Container
//     id="main-content"
//     role="main"
//     aria-label="Dashboard content"
//   >
//     <Row className="justify-content-center g-4">
//       {/* Audio Description Card */}
//       <Col xs={12} sm={6} md={5} lg={4}>
//         <Card
//           className="dashboard-card"
//           tabIndex={0}
//           role="button"
//           aria-label="Audio Description"
//           aria-describedby="audioDescCard"
//           onClick={() => navigate("/Fileupload")}
//           onKeyDown={(e) => e.key === "Enter" && navigate("/Fileupload")}
//         >
//           <Card.Img
//             variant="top"
//             src={loginImg}
//             alt="Illustration for Audio Description page"
//           />
//           <Card.Body className="dashboard-carddiv bg-dark1 text-white text-center">
//             <Card.Title className="fw-bold">Audio Description</Card.Title>
//             <span id="audioDescCard" className="visually-hidden">
//               Click or press Enter to go to the Audio Description page.
//             </span>
//           </Card.Body>
//         </Card>
//       </Col>

//       {/* ISL Video Card */}
//       <Col xs={12} sm={6} md={5} lg={4}>
//         <Card
//           className="dashboard-card"
//           tabIndex={0}
//           role="button"
//           aria-label="ISL "
//           aria-describedby="islVideoCard"
//           onClick={() => navigate("/Isldashboard")}
//           onKeyDown={(e) => e.key === "Enter" && navigate("/Isldashboard")}
//         >
//           <Card.Img
//             variant="top"
//             src={audioconverterImg}
//             alt="Illustration for Indian Sign Language Video page"
//           />
//           <Card.Body className="dashboard-carddiv bg-dark1 text-white text-center">
//             <Card.Title className="fw-bold">ISL </Card.Title>
//             <span id="islVideoCard" className="visually-hidden">
//               Click or press Enter to go to the ISL Video page.
//             </span>
//           </Card.Body>
//         </Card>
//       </Col>
//     </Row>
    
//   </Container>
//                 <Footer />

// </div>



//     // <div role="main" aria-label="Dashboard Page">
//     //   <NavbarComp1 />

//     //   <Container style={{ marginTop: "30px" }} aria-label="Dashboard content">
//     //     <Row className="justify-content-center g-4">
//     //       <Col xs={12} sm={6} md={5} lg={4}>
//     //         <Card
//     //           className="dashboard-card"
//     //           tabIndex={0}
//     //           role="button"
//     //           aria-label="Audio Description: Click to go to Audio Description page"
//     //           onClick={() => navigate("/Fileupload")}
//     //           onKeyDown={(e) => e.key === "Enter" && navigate("/Fileupload")}
//     //         >
//     //           <Card.Img
//     //             variant="top"
//     //             src={loginImg}
//     //             alt="Audio description page illustration"
//     //           />
//     //           <Card.Body className="bg-dark text-white text-center">
//     //             <Card.Title className="fw-bold">
//     //               Audio Description
//     //             </Card.Title>
//     //           </Card.Body>
//     //         </Card>
//     //       </Col>
//     //       <Col xs={12} sm={6} md={5} lg={4}>
//     //         <Card
//     //           className="dashboard-card"
//     //           tabIndex={0}
//     //           role="button"
//     //           aria-label="ISL Video: Click to go to ISL Video page"
//     //           onClick={() => navigate("/Islvideo")}
//     //           onKeyDown={(e) => e.key === "Enter" && navigate("/Islvideo")}
//     //         >
//     //           <Card.Img
//     //             variant="top"
//     //             src={audioconverterImg}
//     //             alt="Indian Sign Language video page illustration"
//     //           />
//     //           <Card.Body className="bg-dark text-white text-center">
//     //             <Card.Title className="fw-bold">
//     //               ISL Video
//     //             </Card.Title>
//     //           </Card.Body>
//     //         </Card>
//     //       </Col>
//     //     </Row>
//     //   </Container>
//     // </div>

//   );
// }

// export default Dashboard;

import React, { useEffect, useContext } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import NavbarComp1 from "../components/Navbar1";
import loginImg from "../images/audio-description.png";
import audioconverterImg from "../images/isl-video.png";
import { UserContext } from "../jsx/UserContext";
import Footer from "../components/Footer";

// Combined CSS to handle full-height layout and responsiveness
const dashboardStyles = `
  .main-div {
    display: flex;
    flex-direction: column;
    min-height: 100vh; /* Ensures it takes full height of screen */
    background-color: #E5E7EB;/* Optional background color */
  }

  .dashboard-wrapper {
    flex: 1; /* Pushes the footer to the bottom */
    display: flex;
    align-items: center; /* Vertical center */
    justify-content: center; /* Horizontal center */
    padding: 20px 0;
  }

  .dashboard-card {
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    border: none;
    border-radius: 15px;
    overflow: hidden;
    height: 100%;
  }

  .dashboard-card:hover, .dashboard-card:focus {
    transform: translateY(-10px);
    box-shadow: 0 10px 20px rgba(0,0,0,0.2);
    outline: none;
  }

  
  /* Prevent vertical scrolling on large screens while allowing it on small ones if content overflows */
  @media (min-height: 700px) {
    .main-div {
      overflow: hidden;
    }
  }
`;

function Dashboard() {
  const { userSession } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    const storedSession = JSON.parse(localStorage.getItem("userSession"));
    if (!storedSession?.access_token || Date.now() > storedSession.expiresAt) {
      localStorage.removeItem("userSession");
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  return (
    <>
      <style>{dashboardStyles}</style>
      <div className="main-div">
        {/* Skip to main content link */}
        <a
          href="#main-content"
          className="visually-hidden-focusable"
          style={{
            position: "absolute",
            top: "-40px",
            left: "0",
            background: "#000",
            color: "#fff",
            padding: "8px 16px",
            zIndex: "1000",
            borderRadius: "4px",
          }}
          onFocus={(e) => (e.target.style.top = "0")}
          onBlur={(e) => (e.target.style.top = "-40px")}
        >
          Skip to main content
        </a>

        <NavbarComp1 />

        <div className="dashboard-wrapper">
          <Container id="main-content" role="main" aria-label="Dashboard content">
            <Row className="justify-content-center g-4">
              {/* Audio Description Card */}
              <Col xs={12} sm={6} md={5} lg={4}>
                <Card
                  className="dashboard-card"
                  tabIndex={0}
                  role="button"
                  aria-label="Audio Description"
                  aria-describedby="audioDescCard"
                  onClick={() => navigate("/Fileupload")}
                  onKeyDown={(e) => e.key === "Enter" && navigate("/Fileupload")}
                >
                  <Card.Img
                    variant="top"
                    src={loginImg}
                    alt="Illustration for Audio Description page"
                    // style={{ height: "200px", objectFit: "cover" }}
                  />
                  <Card.Body className="dashboard-carddiv bg-dark1 text-white text-center">
                    <Card.Title className="fw-bold">Audio Description</Card.Title>
                    <span id="audioDescCard" className="visually-hidden">
                      Click or press Enter to go to the Audio Description page.
                    </span>
                  </Card.Body>
                </Card>
              </Col>

              {/* ISL Video Card */}
              <Col xs={12} sm={6} md={5} lg={4}>
                <Card
                  className="dashboard-card"
                  tabIndex={0}
                  role="button"
                  aria-label="ISL"
                  aria-describedby="islVideoCard"
                  onClick={() => navigate("/Isldashboard")}
                  onKeyDown={(e) => e.key === "Enter" && navigate("/Isldashboard")}
                >
                  <Card.Img
                    variant="top"
                    src={audioconverterImg}
                    alt="Illustration for Indian Sign Language Video page"
                    // style={{ height: "200px", objectFit: "cover" }}
                  />
                  <Card.Body className="dashboard-carddiv bg-dark1 text-white text-center">
                    <Card.Title className="fw-bold">ISL</Card.Title>
                    <span id="islVideoCard" className="visually-hidden">
                      Click or press Enter to go to the ISL Video page.
                    </span>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>

        <Footer />
      </div>
    </>
  );
}

export default Dashboard;
